import React from 'react';
import { Button } from '@fiverr-private/fit';
import { r_paperclip } from '@fiverr-private/icons';

const DEFAULT_SIZE = Button.SIZES.MEDIUM;
const DEFAULT_COLOR = Button.COLORS.LIGHT_GREY;
const DEFAULT_ICON = r_paperclip;

export const DEFAULT_BUTTON = {
    size: DEFAULT_SIZE,
    color: DEFAULT_COLOR,
    icon: DEFAULT_ICON
};
